import { PropsWithChildren } from 'react';
import Radio from '@mui/material/Radio';
import { stylesheet } from 'typestyle';
import { ADALONG_COLORS } from '@src/styles';
import { Row } from '@src/components/Utils';

interface Props {
  value: string;
  checked: boolean;
  onChange: (value: string) => void;
}

export function RadioLine({ value, checked, onChange, children }: PropsWithChildren<Props>) {
  const handleClick = () => onChange(checked ? '' : value);

  return (
    <Row className={styles.line}>
      <Radio
        checked={checked}
        value={value}
        size='small'
        sx={radioSx}
        onClick={(event) => {
          if (checked) {
            event.stopPropagation();
            handleClick();
          }
        }}
      />
      <div className={styles.text} data-checked={checked} onClick={handleClick}>
        {children}
      </div>
    </Row>
  );
}

const styles = stylesheet({
  line: {
    marginBottom: 6,
    cursor: 'pointer',
  },
  text: {
    verticalAlign: 'middle',
    marginLeft: 7,
    width: '100%',
    $nest: {
      '&[data-checked="true"]': {
        color: 'white',
      },
    },
  },
});

const radioSx = {
  color: ADALONG_COLORS.DARK_GRAY,
  padding: 0,
  '&.Mui-checked': {
    color: ADALONG_COLORS.SMOOTH_WHITE,
  },
  '&.Mui-disabled': {
    color: ADALONG_COLORS.DARKER_GRAY,
  },
  '&:hover': {
    backgroundColor: 'transparent',
  },
  '& .MuiSvgIcon-root': {
    fontSize: 15,
  },
};
